<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        class="v-flex__first"
        style="margin-top: 0px !important;"
        xs12>
        <material-card class="v-c3-chart">
          <v-tabs
            v-model="activeIndex"
            dense
            class="mb-0 d-inline-flex flat-tabs"
            background-color="red"
          >
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              :value="tab.value"
              class="custom-tab"
            >
              {{ tab.text }}
            </v-tab>
          </v-tabs>
          <material-notification
            color="brown"
            class="mb-3 h4 font-weight-bold  text-center"
          >
            正態分佈圖
            <p class="m-0">
              Factory：{{ propData.factoryName }} ｜
              PART NUMBER：{{ propData.partNumber }} ｜
              process：{{ propData.process }}｜
              station：{{ propData.station }} |
              parametername：{{ propData.parametername }} |
              periodtype：{{ propData.periodtype }} |
              時間：{{ propData.searchdate }} |
              ModelName:{{ propData.project }}
            </p>
          </material-notification>

          <div class="d-flex">
            <div class="w-50 m-3">
              <div class="keypart-chart-info">
                <div
                  v-if="currentAreaData && currentAreaData.cpk !== null"
                  :class="{
                    'ordinary': doCpkGrade(currentAreaData.cpk),
                    'bad': !doCpkGrade(currentAreaData.cpk)
                  }"
                >
                  <span>CPK</span>
                  <p>{{ currentAreaData.cpk }}</p>
                  <div>
                    <span>{{ currentAreaData.level }}</span>
                  </div>
                </div>
                <div v-if="currentAreaData">
                  <span>SPEC</span>
                  <p v-if="currentAreaData.spec">{{ currentAreaData.spec }}</p>
                  <p v-else>
                    {{ currentAreaData.specLowerValue != null ? currentAreaData.specLowerValue : '-' }}
                    {{ (currentAreaData.specLowerValue != null && currentAreaData.specUpperValue != null) ? ' ~ ' : '' }}
                    {{ currentAreaData.specUpperValue != null ? currentAreaData.specUpperValue : '-' }}
                  </p>
                  <div>
                    <span v-if="currentAreaData.specLowerValue!=null">LOWER</span>
                    <span v-if="currentAreaData.specUpperValue!=null">UPPER</span>
                  </div>
                </div>
                <div v-if="currentAreaData">
                  <span>DATA</span>
                  <p>
                    {{ currentAreaData.min != null ? formatNumber(currentAreaData.min) : '-' }}
                    {{ (currentAreaData.min != null && currentAreaData.max != null) ? ' | ' : '' }}
                    {{ currentAreaData.max != null ? formatNumber(currentAreaData.max) : '-' }}
                  </p>
                  <div>
                    <span v-if="currentAreaData.min!=null">Min</span>
                    <span v-if="currentAreaData.max!=null">Max</span>
                  </div>
                </div>
              </div>

              <table
                v-if="currentAreaData"
                class="keypart-chart-table statistic-table"
              >
                <thead>
                  <tr>
                    <th>sigma</th>
                    <th>value</th>
                    <th>histogram</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Avg-6σ</td>
                    <td>{{ formatNumber(currentAreaData.overNegative6SigmaValue) }}</td>
                    <td>{{ currentAreaData.overNegative6SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg-5σ</td>
                    <td>{{ formatNumber(currentAreaData.overNegative5SigmaValue) }}</td>
                    <td>{{ currentAreaData.overNegative5SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg-4σ</td>
                    <td>{{ formatNumber(currentAreaData.overNegative4SigmaValue) }}</td>
                    <td>{{ currentAreaData.overNegative4SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg-3σ</td>
                    <td>{{ formatNumber(currentAreaData.overNegative3SigmaValue) }}</td>
                    <td>{{ currentAreaData.overNegative3SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg-2σ</td>
                    <td>{{ formatNumber(currentAreaData.overNegative2SigmaValue) }}</td>
                    <td>{{ currentAreaData.overNegative2SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg-1σ</td>
                    <td>{{ formatNumber(currentAreaData.overNegative1SigmaValue) }}</td>
                    <td>{{ currentAreaData.overNegative1SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg+1σ</td>
                    <td>{{ formatNumber(currentAreaData.over1SigmaValue) }}</td>
                    <td>{{ currentAreaData.over1SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg+2σ</td>
                    <td>{{ formatNumber(currentAreaData.over2SigmaValue) }}</td>
                    <td>{{ currentAreaData.over2SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg+3σ</td>
                    <td>{{ formatNumber(currentAreaData.over3SigmaValue) }}</td>
                    <td>{{ currentAreaData.over3SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg+4σ</td>
                    <td>{{ formatNumber(currentAreaData.over4SigmaValue) }}</td>
                    <td>{{ currentAreaData.over4SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg+5σ</td>
                    <td>{{ formatNumber(currentAreaData.over5SigmaValue) }}</td>
                    <td>{{ currentAreaData.over5SigmaQty }}</td>
                  </tr>
                  <tr>
                    <td>Avg+6σ</td>
                    <td>{{ formatNumber(currentAreaData.over6SigmaValue) }}</td>
                    <td>{{ currentAreaData.over6SigmaQty }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="w-50 m-3">
              <div
                class="chart-btn c3-chart c3-click"
                style="margin-top: 0rem!important;"
              >
                <vue-c3
                  v-if="hasSigmaData"
                  :handler="handler_bar"
                />
                <div
                  v-else
                  class="text-center"
                  style="padding: 100px 0;"
                >
                  無 Sigma 資料
                </div>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'PerformanceShowCTQNormaldistributionplot',
  components: {
    VueC3
  },
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      propData: {},
      activeIndex: 0,
      datatype: 4,
      hasSigmaData: true,
      responseAreaData: [],
      handler_bar: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    options_line () {
      const labels = [
        'Avg-6σ', 'Avg-5σ', 'Avg-4σ', 'Avg-3σ', 'Avg-2σ', 'Avg-1σ',
        'Avg+1σ', 'Avg+2σ', 'Avg+3σ', 'Avg+4σ', 'Avg+5σ', 'Avg+6σ'
      ]
      const qtyList = [
        this.currentAreaData.overNegative6SigmaQty,
        this.currentAreaData.overNegative5SigmaQty,
        this.currentAreaData.overNegative4SigmaQty,
        this.currentAreaData.overNegative3SigmaQty,
        this.currentAreaData.overNegative2SigmaQty,
        this.currentAreaData.overNegative1SigmaQty,
        this.currentAreaData.over1SigmaQty,
        this.currentAreaData.over2SigmaQty,
        this.currentAreaData.over3SigmaQty,
        this.currentAreaData.over4SigmaQty,
        this.currentAreaData.over5SigmaQty,
        this.currentAreaData.over6SigmaQty
      ]
      const valueList = [
        this.currentAreaData.overNegative6SigmaValue,
        this.currentAreaData.overNegative5SigmaValue,
        this.currentAreaData.overNegative4SigmaValue,
        this.currentAreaData.overNegative3SigmaValue,
        this.currentAreaData.overNegative2SigmaValue,
        this.currentAreaData.overNegative1SigmaValue,
        this.currentAreaData.over1SigmaValue,
        this.currentAreaData.over2SigmaValue,
        this.currentAreaData.over3SigmaValue,
        this.currentAreaData.over4SigmaValue,
        this.currentAreaData.over5SigmaValue,
        this.currentAreaData.over6SigmaValue
      ]
      const rawData = labels.map((label, index) => ({
        label,
        qty: qtyList[index],
        value: valueList[index]
      }))
      const filteredData = rawData.filter(x => x.value !== 0)
      const xData = filteredData.map(x => x.label)
      const qtyData = filteredData.map(x => x.qty)
      const maxTick = Math.max(2, Math.max.apply(null, qtyData.concat([0])) + 1)
      return {
        data: {
          x: 'x',
          columns: [
            ['x', ...xData],
            ['統計次數', ...qtyData],
            ['正態分佈', ...qtyData]
          ],
          type: 'bar',
          types: {
            正態分佈: 'spline'
          }
        },
        axis: {
          x: {
            type: 'category',
            tick: { rotate: -45, multiline: false }
          },
          y: {
            min: 0,
            max: maxTick,
            padding: { bottom: 0, top: 0 },
            label: { text: '統計次數', position: 'outer-middle' }
          }
        },
        tooltip: {
          contents: (d) => {
            const current = filteredData[d[0].index]
            const amount = d.find(i => i.id === '統計次數')
            return `
      <table class="c3-tooltip">
        <tbody>
          <tr>
            <th colspan="2">${current.label}</th>
          </tr>
          <tr>
            <td>統計次數</td>
            <td>${amount ? amount.value : '-'}</td>
          </tr>
        </tbody>
      </table>
    `
          }
        },
        legend: { show: false },
        size: {
          width: ((window.innerWidth - this.shrink) * 0.5) - 64,
          height: 500
        },
        padding: { top: 20, right: 50, bottom: 0, left: 50 },
        spline: {
          interpolation: { type: 'monotone' }
        }
      }
    },
    tabs () {
      return (this.responseAreaData || []).map((item, index) => ({
        index,
        value: index,
        text: this.getTabName(item.statisticTestItemType)
      }))
    },
    currentAreaData () {
      return this.responseAreaData[this.activeIndex] || {}
    }
  },
  watch: {
    responseAreaData: {
      immediate: true,
      handler (val) {
        if (val && val.length > 0) {
          const index = val.findIndex(
            item => String(item.statisticTestItemType) === String(this.datatype)
          )
          const nextIndex = index !== -1 ? index : 0
          if (this.activeIndex === nextIndex) {
            this.$nextTick(() => {
              this.checkSigmaData()
            })
          } else {
            this.activeIndex = nextIndex
          }
        }
      }
    },
    activeIndex () {
      this.checkSigmaData()
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctqThermalPerformance/CTQAnalyzer/ShowCTQNormaldistributionplot')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          const cache = sessionStorage.getItem('cachePerfFilterInfo')
          if (cache) {
            this.propData = JSON.parse(cache)
          } else {
            const raw = localStorage.getItem('ctqPerfFilterInfo')
            if (raw) {
              this.propData = JSON.parse(raw)
              sessionStorage.setItem('cachePerfFilterInfo', raw)
            }
          }
          this.datatype = this.$route.query.statisticTestItemType || 4
          this.loadingView = true
          this.doSubmit()
          this.loadingView = false
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    doSummary (type) {
      if (type === 'init') {
        this.handler_bar.$emit('init', this.options_line)
      } else {
        this.handler_bar.$emit('dispatch', chart => {
          const options = {
            columns: [this.barXaxisName].concat(this.barXaxisValue)
          }
          chart.load(options)
        })
      }
    },
    checkSigmaData () {
      if (!this.responseAreaData || this.responseAreaData.length === 0) {
        return
      }
      const sigmaValues = [
        this.currentAreaData.overNegative6SigmaValue,
        this.currentAreaData.overNegative5SigmaValue,
        this.currentAreaData.overNegative4SigmaValue,
        this.currentAreaData.overNegative3SigmaValue,
        this.currentAreaData.overNegative2SigmaValue,
        this.currentAreaData.overNegative1SigmaValue,
        this.currentAreaData.over1SigmaValue,
        this.currentAreaData.over2SigmaValue,
        this.currentAreaData.over3SigmaValue,
        this.currentAreaData.over4SigmaValue,
        this.currentAreaData.over5SigmaValue,
        this.currentAreaData.over6SigmaValue
      ].map(v => Number(v || 0))
      this.hasSigmaData = new Set(sigmaValues).size > 1
      if (!this.hasSigmaData) {
        this.snackbar = true
        this.snackbarColor = 'orange'
        this.snackbarMsg = '無 Sigma 資料'
      } else {
        this.$nextTick(() => {
          this.doSummary('init')
        })
      }
    },
    parseSpec (spec) {
      const parts = String(spec || '').split('~').map(s => s.trim())
      const keep = (v) => (v ? v : null)
      return {
        lower: keep(parts[0]),
        upper: keep(parts[1])
      }
    },
    plotItemType (item) {
      if (item.statisticTestItemType) return Number(item.statisticTestItemType)
      const name = String(item.testItemName || item.parameterName || '')
      if (name.indexOf('最小值') !== -1) return 5
      if (name.indexOf('最大值') !== -1) return 6
      return 4
    },
    cpkLevel (cpk) {
      const n = Number(cpk)
      if (!isFinite(n)) return ''
      if (n >= 1.67) return 'Excellent'
      if (n >= 1.33) return 'Good'
      if (n >= 1) return 'OK'
      return 'Poor'
    },
    decoratePlotRow (row) {
      const spec = this.parseSpec(row.spec)
      return Object.assign({}, row, {
        specLowerValue: row.specLowerValue != null ? row.specLowerValue : spec.lower,
        specUpperValue: row.specUpperValue != null ? row.specUpperValue : spec.upper,
        level: row.level || this.cpkLevel(row.cpk),
        statisticTestItemType: this.plotItemType(row)
      })
    },
    doSubmit () {
      const list = (this.propData && this.propData.responseData) || []
      if (!list.length) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '查無資料'
        return
      }
      this.responseAreaData = list.map(this.decoratePlotRow)
      if (!this.propData.factoryName && this.responseAreaData[0]) {
        const rec = this.responseAreaData[0]
        this.propData.factoryName = rec.vendorCode || rec.vendor
        this.propData.partNumber = rec.partNumber
        this.propData.process = rec.processName
        this.propData.station = rec.stationName
        this.propData.parametername = rec.testItemName || rec.parameterName
        this.propData.project = rec.modelName
      }
    },
    doCpkGrade (cpk) {
      return Number(cpk) >= 1.33
    },
    getTabName (type) {
      const map = {
        4: '實測',
        5: '實測最小',
        6: '實測最大'
      }
      return map[type] || '未知'
    },
    formatNumber (value) {
      return value != null ? value : '-'
    }
  }
}
</script>
<style>
.v-tabs {
  width: auto !important;
}
.v-tabs .v-tab {
  background: transparent !important;
  color: #333;
  border-radius: 6px;
  transition: 0.2s;
}
.v-tabs .v-tab--active {
  background: #8d6e63 !important;
  color: #fff !important;
}
.v-tabs .v-tab:hover {
  background: rgba(141, 110, 99, 0.15);
}
</style>
